var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeat9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3489_6883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.10547 17.1132V23.2442H10.7476C11.05 23.2443 11.3496 23.1847 11.629 23.069C11.9084 22.9533 12.1624 22.7837 12.3763 22.5698L22.5832 12.3629C23.0158 11.9313 23.2593 11.3455 23.2602 10.7342V2.10547H17.1292V14.8074C17.1296 15.1123 17.0694 15.4143 16.9521 15.6958C16.8348 15.9773 16.6629 16.2326 16.4462 16.4472C16.2295 16.6617 15.9722 16.831 15.6896 16.9454C15.4068 17.0597 15.1043 17.1167 14.7994 17.1132H2.10547Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8689 22.8771V16.7461H29.2268C28.9244 16.7461 28.6248 16.8056 28.3454 16.9214C28.066 17.037 27.812 17.2066 27.5981 17.4205L17.3912 27.6274C17.1774 27.8413 17.0077 28.0951 16.8921 28.3746C16.7764 28.6541 16.7168 28.9536 16.7168 29.2561V37.8928H22.8478V25.1803C22.8478 24.8776 22.9075 24.5779 23.0234 24.2983C23.1393 24.0187 23.3092 23.7646 23.5234 23.5507C23.7375 23.3368 23.9917 23.1673 24.2715 23.0517C24.5512 22.9361 24.851 22.8768 25.1536 22.8771H37.8689Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3489_6883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat9);
export default __webpack_public_path__ + "static/media/feat-9.8829be67def47338b6cd81e287038c52.svg";
export { ForwardRef as ReactComponent };